// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"y_sK h_jm h_fm h_fq h_fB h_dJ h_t","menuItemSub":"y_sL h_dQ h_fm h_fB","menuMainLink":"y_sM h_jn h_hh","menuLink":"y_sN h_jn h_hh","Link":"y_rj r_rj r_qz r_qV"};